module.exports = __webpack_public_path__ + "img/mobile-banner0-tw.a7ad3bf8.jpg";